$(function() {
    function initTabs(tab, tabContent, activeClass) {
        $(tabContent).not(':first').hide();
        $(tab).first().addClass(activeClass);

        $(tab).on('click', function H() {
            $(tab).removeClass(activeClass).eq($(this).index())
                .addClass(activeClass);
            $(tabContent).hide().eq($(this).index())
                .fadeIn();
        });
    }

    const $tabs = $('.js-tabs');

    $tabs.each(function () {
        let $tab = $(this).find('.js-tab'),
            $tabsContent = $(this).find('.js-tab-content');

        initTabs($tab, $tabsContent, 'active-tab');
    });
});